import React, { useContext } from 'react'

import StoreContext from '~/context/StoreContext'
import ListItems from './LineItem/ListItems'
import styled from '@emotion/styled'

const Container = styled.div`
    min-height: 700px;
`;

const ButtonContainer= styled.div`
    width: 90%;
`;

const ButtonCh = styled.button`
        margin-top: 15px;
        border: none;
        outline: 0;
        padding: 12px;
        color: white;
        background-color: #000;
        text-align: center;
        cursor: pointer;
        width: 200px;
        font-size: 18px;
        border-radius: 3px;
        float: right;
`;


const Cart = () => {
    const {
        store: { checkout },

    } = useContext(StoreContext)

    const handleCheckout = () => {
        window.open(checkout.webUrl)
    }

    return (
        <Container>
            <ListItems 
                items={checkout.lineItems} 
                subtotal = {checkout.subtotalPrice}
                taxes = {checkout.totalTax}
                total = {checkout.totalPrice}
            />
            <div className="clearfix"></div>
            <ButtonContainer>
                <ButtonCh onClick={handleCheckout} disabled={checkout.lineItems.length === 0}>Check out</ButtonCh>
            </ButtonContainer>
        </Container>
    )
}

export default Cart
